import React, { FunctionComponent, useMemo } from 'react';
import { isArray } from '@/utils/isArray';
import { Col, createArrayInRange, Row } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';

import commonStyles from '../SolutionsPage.module.scss';
import styles from './ForOrganisations.module.scss';

type SolutionsForOrganisationsType = {
  key: number;
  title: string;
  subtitle: string;
  description: string[];
  imageName: {
    lg: string;
    md: string;
    xs: string;
  };
};

const ForOrganisations: FunctionComponent = () => {
  const { t, i18n } = useTranslation();
  const solutionsForOrganisations = useMemo(
    () =>
      createArrayInRange(0, 1).map((index) => ({
        key: index,
        title: t(`solutions.for-organisations.${index}.title`),
        subtitle: t(`solutions.for-organisations.${index}.subtitle`),
        description: t(`solutions.for-organisations.${index}.description`, { returnObjects: true }) as string[],
        imageName: {
          lg: `/images/solutions/organisations-${index}-lg.png`,
          md: `/images/solutions/organisations-${index}-md.png`,
          xs: `/images/solutions/organisations-${index}-xs.png`,
        },
      })),
    [i18n.language]
  );

  return (
    <div className={styles.organisations}>
      {solutionsForOrganisations.map((solution: SolutionsForOrganisationsType, i) => (
        <Row key={solution.key} className={styles['organisations-item']}>
          <Col
            xs={12}
            lg={5}
            className={cx(styles['organisations-item__text'], `order-1 ${i % 2 === 0 && 'order-lg-0'}`)}
          >
            {solution.title && <h2 style={{ marginTop: 50 }}>{solution.title}</h2>}
            <h3>{solution.subtitle}</h3>
            {isArray(solution.description) &&
              solution.description.map((description, index) => (
                <p key={index} className={commonStyles['description-small']}>
                  {description}
                </p>
              ))}
          </Col>
          <Col xs={12} lg={7} className={styles['organisations-item__image']}>
            <img
              srcSet={`${solution.imageName.xs} 420w, ${solution.imageName.md} 570w, ${solution.imageName.lg} 800w`}
              sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
              style={i % 2 === 1 ? { left: 0 } : { right: 0 }}
              alt={solution.title}
            />
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default ForOrganisations;
